module.exports = __webpack_public_path__ + "static/media/slide1.349590fb.jpg";